import { toast } from 'vue-sonner';

type HFetchArgs<B> = {
  url: string;
  method?: 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE';
  payload?: B;
};
/**
 * @deprecated Use `lib/hfetch/index.ts` instead as it follows the Humaniz standard for api shapes.
 */
export const hFetch = async <T, B = undefined>({ url, method = 'GET', payload }: HFetchArgs<B>) => {
  const response = await fetch(url, {
    method,
    headers: buildHeaders(payload),
    body: payload instanceof FormData ? payload : JSON.stringify(payload),
  });

  if (hasNoContent(response)) return;

  try {
    return (await response.json()) as T;
  } catch {
    return undefined;
  }
};

const buildHeaders = <B>(payload?: B) => {
  const headers: HeadersInit = {};

  if (!(payload instanceof FormData)) {
    headers['Content-Type'] = 'application/json';
    headers['Accept'] = 'application/json';
  }

  const csrfToken = document.querySelectorAll('[name="csrf-token"]')[0];
  if (csrfToken && csrfToken instanceof HTMLMetaElement) {
    headers['X-CSRF-TOKEN'] = csrfToken.content;
  }

  return headers;
};

const hasNoContent = (response: Response) => response.status === 204;

export type HError = {
  status: string;
  message: string;
};

type PublishErrorUnlessSuccessArgs = {
  data: HError;
  alertTitle: string;
};

/**
 * @deprecated The method should not be used.
 * It attempts to mix the api layer with the ui layer and leads to bad design.
 * The throw assumes that any error is unexpected, we can expect bad user data and should handle it.
 * Handle the api response at the view on a case by case basis.
 */
export const publishErrorUnlessSuccess = ({ data, alertTitle }: PublishErrorUnlessSuccessArgs) => {
  if (data?.status === 'error') {
    toast.error(alertTitle, {
      action: { label: 'Dismiss' },
      description: data.message,
    });
    throw new Error(data.message);
  }
};
